import { render, staticRenderFns } from "./MethodAssessment.vue?vue&type=template&id=26a5f1aa"
import script from "./MethodAssessment.vue?vue&type=script&lang=js"
export * from "./MethodAssessment.vue?vue&type=script&lang=js"
import style0 from "./MethodAssessment.vue?vue&type=style&index=0&id=26a5f1aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports